import DropdownMenu from '@components/std-components/DropdownMenu'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IQuantityType } from '../models/QuantityType'
import * as css from './QuantityType.css'

export default function QuantityType({
  options,
  type,
  setType
}: IQuantityType): JSX.Element {
  const { t } = useTranslation()
  return useObserver(function useHook() {
    return (
      <div className={css['quantityTypeContainer']}>
        <div className={css['quantityTypeLabel']}>
          <Typography variant={'captionGrey'}>
            {t('common.label.calculatingWith', 'Calculating With:')}
          </Typography>
        </div>
        <DropdownMenu
          options={options}
          selected={[type]}
          onSelect={({ selected }) => setType(selected[0])}
          title={'Select Quantity Type'}
          multiple={false}
          showIcon={true}
          contentStyle={{
            width: 160
          }}
        />
      </div>
    )
  })
}
